<script setup>
import NeedSidebar from "@/views/ecosystem/needs/need/NeedSidebar.vue";
import {useRoute} from "vue2-helpers/vue-router";
import {onMounted, provide, ref} from "vue";
import needsService from "@/services/ecosystem/needs.service";
import SuggestedStartupsTable from "@/views/ecosystem/needs/need/SuggestedStartupsTable.vue";
import SubmittedStartupsTable from "@/views/ecosystem/needs/need/SubmittedStartupsTable.vue";
import AllStartupsTable from "@/views/ecosystem/needs/need/AllStartupsTable.vue";
import NeedStartupSubmitModal from "@/components/ecosystem/NeedStartupSubmitModal.vue";
import useTrigger from "@/composables/useTrigger";

const route = useRoute();
const [updateStartups, setNeedUpdateStartups] = useTrigger();

const need = ref(null);
const submitModal = ref(null);

onMounted(() => {
    getInfo();
});

async function getInfo() {
    const {data} = await needsService.getInfo(route.params.id);

    need.value = data;
}

function submitStartup(id) {
    submitModal.value.open(id);
}

provide('need', need);
provide('updateStartups', updateStartups);
</script>

<template>
    <div v-if="need" class="dashboard-page">
        <NeedSidebar/>

        <main class="dashboard-page__main">
            <SubmittedStartupsTable/>

            <SuggestedStartupsTable
                @submitStartup="submitStartup"
            />

            <AllStartupsTable
                @submitStartup="submitStartup"
            />
        </main>

        <NeedStartupSubmitModal
            ref="submitModal"
            @submitted="setNeedUpdateStartups"
        />
    </div>
</template>

<style scoped>

</style>
